module.exports = __webpack_public_path__ + "img/fr.c504bc79.svg";